import AlertIcon from "~icons/local/alert";
import Button from "@/lib/Button";
import $api from "@/lib/queries/openapi";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";

export default function OutdatedWarning({
  partId,
  clearLocalLineItems,
}: {
  partId: string;
  clearLocalLineItems: () => void;
}) {
  const { teamSlug } = useParams();
  const queryClient = useQueryClient();

  const { mutate: resetLineItems, isPending } = $api.useMutation(
    "post",
    "/api/teams/{team_slug}/requested_parts/{id}/reset_line_items",
    {
      onSuccess: () => {
        clearLocalLineItems();
        queryClient.invalidateQueries({
          queryKey: [
            "get",
            "/api/teams/{team_slug}/quote_revisions/{id}/line_items",
          ],
        });
      },
    },
  );

  return (
    <div className="text-red-600 bg-red-50 rounded-lg px-2 py-1 text-xs flex items-center gap-1 justify-between">
      <div className="flex gap-1 items-center">
        <AlertIcon className="size-7" />
        <span className="font-bold">Warning:</span>
        <span>Part Estimate has been edited</span>
      </div>
      <Button
        size="sm"
        loading={isPending}
        onClick={() =>
          resetLineItems({
            params: {
              path: {
                id: partId,
                team_slug: teamSlug!,
              },
            },
          })
        }
      >
        Reset
      </Button>
    </div>
  );
}
